<app-landing-area></app-landing-area>
<app-flat-profile></app-flat-profile>
<app-booking></app-booking>
<app-footer></app-footer>
